import { useEffect, useState } from "react";
import apiFetch from "../../../../../shared/services/apiClient";
import FilialDetailsSummary from "./FilialDetailsSummary";
import styles from "../../styles/addInvoice.module.css";

function FieldError({ msg }) {
  if (!msg) return null;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 5,
        color: "#f87171",
        fontSize: "0.77rem",
        marginTop: 4,
        fontWeight: 500,
      }}
    >
      <i
        className="fa-solid fa-circle-exclamation"
        style={{ fontSize: "0.72rem" }}
      />
      {msg}
    </div>
  );
}

export default function FilialDetailsBody({
  invoiceData,
  updateField,
  errors = {},
}) {
  const [filiales, setFiliales] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await apiFetch("/api/residents/propietario/");
        const data = await res.json();
        setFiliales(data.results ?? data ?? []);
      } catch {
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  // Auto-seleccionar primera filial cuando:
  // a) filiales acaban de cargar (primer render)
  // b) invoiceData.filial vuelve a 0 (después de resetFields)
  useEffect(() => {
    if (filiales.length > 0 && invoiceData.filial === 0) {
      const first = filiales[0];
      updateField("filial", first.filial_data?.id || first.filial?.id || first.filial);
      updateField("nombre_propietario", first.persona?.nombre_completo || first.persona?.nombre || "");
      resolverCuentaCxc(first.filial_data?.id || first.filial?.id || first.filial);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filiales, invoiceData.filial]);

  function handleChange(id) {
    const owner = filiales.find((f) => (f.filial_data?.id || f.filial?.id || f.filial) === id);
    if (!owner) return;
    updateField("filial", owner.filial_data?.id || owner.filial?.id || owner.filial);
    updateField("nombre_propietario", owner.persona?.nombre_completo || owner.persona?.nombre || "");
    // Resolver cuenta CxC de esta filial en el catálogo (silencioso, sin UI)
    resolverCuentaCxc(id);
  }

  async function resolverCuentaCxc(filialId) {
    try {
      // La cuenta CxC de la filial está en el catálogo bajo "Cuentas por Cobrar"
      // con filial FK = filialId. El endpoint /catalogo/detalle/ la incluye.
      const res  = await apiFetch(`/api/finance/catalogo/detalle/?tipo=ACTIVO`);
      const data = await res.json();
      const cuentas = Array.isArray(data) ? data : (data.results ?? []);
      // La cuenta de la filial tiene el nombre igual al idFilial de la filial
      const owner  = filiales.find((f) => (f.filial_data?.id || f.filial?.id || f.filial) === filialId);
      if (!owner) return;
      const cuenta = cuentas.find((c) => c.nombre === (owner.filial_data?.idFilial || owner.filial?.idFilial));
      updateField("cuenta_cxc", cuenta ? cuenta.id : null);
    } catch (_) {
      updateField("cuenta_cxc", null);
    }
  }

  return (
    <div className={styles["invoice-details-body"]}>
      <label>
        Filial <span style={{ color: "#f87171" }}>*</span>
      </label>

      {loading ? (
        <div
          style={{ color: "#9ca3af", fontSize: "0.85rem", padding: "8px 0" }}
        >
          Cargando filiales…
        </div>
      ) : filiales.length === 0 ? (
        <div
          style={{
            background: "rgba(239,68,68,0.08)",
            border: "1px solid rgba(239,68,68,0.3)",
            borderRadius: 6,
            padding: "10px 14px",
            color: "#f87171",
            fontSize: "0.83rem",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <i className="fa-solid fa-triangle-exclamation" />
          No hay filiales registradas. Agregá un residente primero.
        </div>
      ) : (
        <>
          <select
            className="form-select"
            value={invoiceData.filial}
            onChange={(e) => handleChange(Number(e.target.value))}
            style={errors.filial ? { borderColor: "#ef4444" } : undefined}
          >
            {filiales.map((f) => (
              <option key={f.id} value={f.filial_data?.id || f.filial?.id || f.filial}>
                {f.filial_data?.idFilial || f.filial?.idFilial || f.filial}
              </option>
            ))}
          </select>
          <FieldError msg={errors.filial} />
        </>
      )}

      <label style={{ marginTop: 12 }}>Propietario</label>
      <input
        className="form-control"
        value={invoiceData.nombre_propietario}
        disabled
        style={{ opacity: 0.7 }}
      />

      <FilialDetailsSummary invoiceData={invoiceData} />
    </div>
  );
}

